<template>
    <PageWrapper>
        <template #headline>
            <fa icon="fa-paint-roller" />
            {{ $t('customize') }} {{ platform }}
        </template>
        <template #actions>
            <BackButton
                @click="
                    router.push({
                        name: 'platform',
                        params: { slug: platform },
                    })
                "
            />
        </template>
        <div class="flex h-auto w-auto min-w-0 items-start justify-start">
            <div
                class="flex w-auto min-w-0 flex-nowrap gap-2 overflow-x-auto rounded-lg bg-gray-200 p-2"
            >
                <div
                    v-for="tab in tabs"
                    :key="tab.name"
                    :class="[
                        'flex h-auto shrink-0 cursor-pointer items-center justify-center rounded-md px-4 py-2 text-sm',
                        {
                            'bg-primary-accent-500 text-white shadow-md':
                                selectedTab === tab.value,
                            'bg-slate-100 text-gray-900':
                                selectedTab !== tab.value,
                        },
                    ]"
                    @click="selectedTab = tab.value"
                >
                    <fa
                        :icon="tab.icon"
                        class="mr-2"
                    />
                    {{ tab.name }}
                </div>
            </div>
        </div>
        <div
            v-if="tabs.find((tab) => tab.value === selectedTab)?.component"
            class="mt-4"
        >
            <component
                :is="tabs.find((tab) => tab.value === selectedTab)?.component"
            />
        </div>
    </PageWrapper>
</template>

<script setup lang="ts">
import BackButton from '@src/partials/actions/BackButton.vue'
import PageWrapper from '@src/partials/pages/PageWrapper.vue'
import { type Component, defineAsyncComponent, ref, shallowRef } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const route = useRoute()
const router = useRouter()
const platform = route.params.slug as string

const selectedTab = ref<string>('customize_content')

const tabs = shallowRef<
    { name: string; value: string; icon: string; component?: Component }[]
>([
    {
        name: 'Theme Settings',
        value: 'theme_settings',
        icon: 'fa-brush',
        component: defineAsyncComponent(
            () => import('@src/partials/platforms/ThemeSettingsForm.vue')
        ),
    },
    {
        name: 'Customize Content',
        value: 'customize_content',
        icon: 'fa-quote-left',
        component: defineAsyncComponent(
            () => import('@src/partials/platforms/CustomizeContentTab.vue')
        ),
    },
    // Disabled for now: PlatformTranslationsForm.vue depends on the shared
    // @translations dictionary from the conda-mono frontend, which isn't
    // available in this standalone repo. Re-enable once that dependency
    // is resolved.
    // {
    //     name: 'Translations',
    //     value: 'translations',
    //     icon: 'fa-language',
    //     component: defineAsyncComponent(
    //         () => import('@src/partials/platforms/PlatformTranslationsForm.vue')
    //     ),
    // },
    // {
    //     name: 'Page Builder',
    //     value: 'page_builder',
    //     icon: 'fa-layer-group',
    //     component: defineAsyncComponent(
    //         () => import('@src/partials/pageBuilder/PageBuilderSection.vue')
    //     ),
    // },

    // {
    //     name: 'Menus',
    //     value: 'menus',
    //     icon: 'fa-list',
    //     component: defineAsyncComponent(
    //         () => import('@src/partials/pageBuilder/PlatformMenusForm.vue')
    //     ),
    // },
])
</script>
